var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-audiograms.ebd84e55.png","uri@2x": __webpack_public_path__ + "icon-audiograms.7c55c9de.png","uri@3x": __webpack_public_path__ + "icon-audiograms.df57f22f.png",
    width: 20,
    height: 20
});